import { jsx as _jsx } from "react/jsx-runtime";
import { Link, Anchor } from "@faire/web--source/ui/LinkAnchor";
import trackClick from "@faire/web-api--source/api/click-track/post";
import { trackRetailersTopNavClick } from "@faire/web-api--source/events/retailers/click/topNav";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import React from "react";
var COMPONENT_NAME = "desktop-header-category-dropdown";
var MOST_POPULAR_FILTER_KEY = "most_popular";
export var NavigationLink = function(param) {
    var children = param.children, link = param.link, onClick = param.onClick, onMouseEnter = param.onMouseEnter, onFocus = param.onFocus, className = param.className, dataTestId = param.dataTestId, style = param.style;
    var onClickWithTracking = React.useCallback(function() {
        if (link.categoryPathIdentifier) {
            var _link_to;
            var eventToken = link.categoryPathIdentifier;
            if ((_link_to = link.to) === null || _link_to === void 0 ? void 0 : _link_to.includes(MOST_POPULAR_FILTER_KEY)) {
                eventToken = "".concat(eventToken, "|").concat(MOST_POPULAR_FILTER_KEY);
            }
            trackRetailersTopNavClick(eventToken);
            trackClick(IClickInfo.build({
                container_name: COMPONENT_NAME,
                token: link.categoryPathIdentifier,
                type: IClickInfo.Type.CATEGORY
            }));
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    }, [
        link,
        onClick
    ]);
    if (!link.to) {
        return /*#__PURE__*/ _jsx("div", {
            style: style,
            onClick: onClickWithTracking,
            onMouseEnter: onMouseEnter,
            onFocus: onFocus,
            className: className,
            "aria-label": link.name,
            "data-test-id": dataTestId,
            children: children
        });
    }
    return link.to.startsWith("http") ? /*#__PURE__*/ _jsx(Anchor, {
        href: link.to,
        style: style,
        onClick: onClickWithTracking,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        className: className,
        "aria-label": link.name,
        "data-test-id": dataTestId,
        children: children
    }) : /*#__PURE__*/ _jsx(Link, {
        to: link.to,
        style: style,
        onClick: onClickWithTracking,
        onMouseEnter: onMouseEnter,
        onFocus: onFocus,
        className: className,
        "aria-label": link.name,
        "data-test-id": dataTestId,
        children: children
    });
};
